import type { Workspace } from '@/entities/workspace/workspace-types';
import type { EventOptions } from '@amplitude/analytics-browser/lib/esm/types';

import { getPageName } from '@/shared/utils/get-page-name';
import type { User } from '../../entities/user/user-types';
import { initAmplitude, trackAmplitudeEvent } from './amplitude';
import type { Feature, FeatureActionMap } from './events';
import { identifyGTM, trackGtmEvent } from './gtm';
import { initSmartlook } from './smartlook';

export const initTrack = (user: User, workspace: Workspace) => {
  if (import.meta.env.VITE_ENVIRONMENT !== 'prod') return;
  initAmplitude(user, workspace);
  initSmartlook(user, workspace);
  identifyGTM(user, workspace);
};

export const trackEvent = <T extends Feature>(
  feature: T,
  action: FeatureActionMap[T],
  eventProperties?: Record<string, unknown>,
  eventOptions?: EventOptions,
) => {
  if (import.meta.env.VITE_ENVIRONMENT !== 'prod') return;
  const event = {
    action,
    feature,
    name: `${feature}.${action}`,
    properties: {
      pageName: getPageName(window.location.pathname),
      ...eventProperties,
    },
  };

  trackAmplitudeEvent(event, eventOptions);
  trackGtmEvent(event);
};
